import React from "react";

import { EntrataUsersTable } from "../../../components/EntrataUsersTable";
import { MainLayout } from "../../../layout/MainLayout";
import useAuth from "../../login/AuthContext";

export const ENTRATA_URL = "/super-admin/entrata";

export const EntrataUsersContainer: React.FC = () => {
  const { isWriteAccess } = useAuth();
  return (
    <MainLayout title="Entrata">
      {isWriteAccess() && (
        <EntrataUsersTable />
      )}
    </MainLayout>
  );

};